import config from '@/config'
import io from 'socket.io-client'

const socket = {
  install(Vue) {
    Vue.mixin({
      data: () => ({
        socket: null,
      }),

      methods: {
        createSocket(userSeq) {
          if (this.socket === null || !this.socket.connected) {
            this.socket = io(config.socket.uri, config.socket.option)
            this.socket.on('connect', () => {
              this.socket.emit('login', userSeq)
              this.socket.on(config.socket.event.worker, (message) => {
                this.onWorkerMessageReceived(JSON.parse(message))
              })
            })
          }
        },

        closeSocket() {
          this.socket.close()
        },

        onWorkerMessageReceived(msg) {
          let path = null
          const currentPage = this.$route.name
          switch (msg.id) {
            case 'updateSLACredit':
              path =
                currentPage !== 'invoiceCredit' ? '/admin/invoice_credit' : null
              break
            case 'createInvoice':
              path =
                currentPage !== 'invoiceDelivery'
                  ? '/admin/invoice_delivery'
                  : null
              break
            case 'createTencentInvoice':
              path =
                currentPage !== 'invoiceDelivery'
                  ? '/admin/invoice_delivery'
                  : null
              break
            case 'createAkamaiInvoice':
              path =
                currentPage !== 'invoiceDelivery'
                  ? '/admin/invoice_delivery'
                  : null
              break
            default:
              return
          }

          let action
          if (path === null) {
            action = () => {
              this.$evt.$emit('reload')
            }
          } else {
            action = () => {
              this.$router.push(path)
            }
          }

          this.$store.dispatch('dialog/showConfirm', {
            message: `${msg.id} ${this.C('complete')}`,
            confirmText: 'Check results',
            cancelText: 'Cancel',
            action,
          })
        },
      },
    })
  },
}

export default socket
